import FormType from "../../Components/Form2/FormType";
import location1 from "../../Assets/Images/location_one.jpeg";
import location2 from "../../Assets/Images/location_two.png";

const SiteDocumentationFormOptions = (init = {}) => {
	return {
		Fields: [
			{
				element: FormType.Input,
				name: "primaryLocationName",
				label: "Primary Location",
				placeholder: "e.g. Building Frontage",
				value: init.primaryLocationName || "",
				required: true,
				info: "Primary location example",
				infoImage: location1,
			},
			{
				element: FormType.FileUpload,
				name: "primaryLocation",
				label: "Starlink Antenna Location 1 ",
				description:
					"Select an image for the primary location (e.g., rooftop, wall).",
				value: init.primaryLocation || [],
				required: true,
				fileTypes: "image",
			},
			{
				element: FormType.Input,
				name: "secondaryLocationName",
				label: "Secondary Location",
				placeholder: "e.g. Building Rooftop",
				value: init.secondaryLocationName || "",
				required: false,
				info: "Secondary location example",
				infoImage: location2,
			},
			{
				element: FormType.FileUpload,
				name: "secondaryLocation",
				label: "Starlink Antenna Location 2",
				description:
					"Select an image for the secondary location (e.g., rooftop, wall).",
				value: init.secondaryLocation || [],
				changeEvent: true,
				required: false,
				fileTypes: "image",
			},
			{
				element: FormType.TextArea,
				name: "obstructionDescription",
				label: "Check for Obstructions",
				description:
					"Ensure that each selected installation location has an unobstructed view of the sky.",
				value: init.obstructionDescription || "",
				infoImage: "/samples/obstruction.png",
				required: true,
			},
			{
				element: FormType.CheckBoxList,
				name: "scaffoldRequired",
				label: "Is a scaffold required for the installation?",
				options: [
					{ label: "Yes", value: "yes" },
					{ label: "No", value: "no" },
				],
				value: init.scaffoldRequired || "",
				required: true,
			},
			{
				element: FormType.CheckBoxList,
				name: "ladderRequired",
				label: "Is a ladder required for the installation?",
				options: [
					{ label: "Yes", value: "yes" },
					{ label: "No", value: "no" },
				],
				value: init.ladderRequired || "",
				required: true,
			},
			{
				element: FormType.CheckBoxList,
				name: "trunkingRequired",
				label: "Is a trunking pipe required for the installation?",
				options: [
					{ label: "Yes", value: "yes" },
					{ label: "No", value: "no" },
				],
				value: init.trunkingRequired || "",
				required: true,
			},
		],
	};
};

export default SiteDocumentationFormOptions;
